import { Dialog, Transition } from '@headlessui/react';
import React, { Fragment } from 'react';
import { Segment, getContrastingColor, truncateString } from './utils';

interface WinnerDialogProps {
  isOpen: boolean;
  segment: Segment | undefined;
  onClose: () => void;
  onRemoveItemAndClose: (segment: Segment) => void;
}

const WinnerDialog: React.FC<WinnerDialogProps> = ({
  segment,
  isOpen,
  onClose,
  onRemoveItemAndClose,
}) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-2 sm:p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className="w-full max-w-md transform overflow-hidden rounded-2xl p-3 sm:p-4 pb-3 text-left align-middle shadow-xl transition-all border-4"
                style={{ background: segment?.color }}
              >
                <p
                  className="text-xl font-semibold w-full flex justify-center"
                  style={{
                    color: getContrastingColor(segment?.color || 'white'),
                  }}
                >
                  {segment?.label}
                </p>

                <div className="mt-6 flex justify-end gap-2">
                  <button
                    type="button"
                    className="ph-no-capture inline-flex justify-center items-center rounded-md border-2 border-white bg-gray-100 px-2 py-1.5 text-sm font-medium text-gray-900 hover:bg-gray-200 shadow-sm"
                    onClick={() => segment && onRemoveItemAndClose(segment)}
                  >
                    Remove "{truncateString(segment?.label || '', 9)}" and
                    continue
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M18 12H6"
                      />
                    </svg>
                  </button>
                  <button
                    type="button"
                    className="inline-flex justify-center items-center rounded-md border-2 border-white bg-gray-100 px-3 py-1.5 text-sm font-medium text-gray-900 hover:bg-gray-200 shadow-sm"
                    onClick={onClose}
                  >
                    Continue
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M13 7l5 5m0 0l-5 5m5-5H6"
                      />
                    </svg>
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default WinnerDialog;
